export function menuListByFilterQuery(filter) {
  const query = `{menuListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}){id, name, active, inDetail, studentQuantity, fileUrl, fileId, fileName, fileType}}`;
  return query;
}

export function saveMenuMutation(values, file) {
  const menuItems = [];
  if (values.inDetail) {
    for (let i = 0; i < values.menuItems.menuColumns.length; i += 1) {
      for (
        let j = 0;
        j < values.menuItems.menuColumns[i].menuItems.length;
        j += 1
      ) {
        menuItems.push(values.menuItems.menuColumns[i].menuItems[j]);
      }
    }
  }
  const mutationQuery = `mutation {
        menuSave(
            menu: {
                id: ${values.id},
                name: "${values.name}",
                active: ${values.active},
                inDetail: ${values.inDetail},
                fileId: "${file ? file.fileId : ''}"
                deleted: false,
                studentQuantity: ${values.students.length},
                filterByStatus: false,
                updaterId: 0,
                menuItems: ${JSON.stringify(menuItems).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
                students:  ${JSON.stringify(values.students).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
            }),
        {id}
    }`;
  return mutationQuery;
}

export function removeMenuMutation(id) {
  const mutationQuery = `mutation {menuRemove(id: ${id})}`;
  return mutationQuery;
}

export function loadMenuFormWrapper(menuId, referenceDate) {
  const query = `{
    loadMenuFormWrapper(id: ${menuId}, referenceDate: ${referenceDate}) {initialDateInMilli, finalDateInMilli, meals{id, name, active}, menuColumns{dateInMilli, menuItems{id, dateInMilli, menuId, mealId, menuItemDescription}}}
   }`;
  return query;
}

export function copyMenuItems(refDate, initialDate, finalDate, menuId) {
  const mutation = `mutation {
    copyMenuItems(refDate: ${refDate}
                , initialDate: ${initialDate}
                , finalDate: ${finalDate}
                , menuId: ${menuId})}
`;
  return mutation;
}

export function saveMealMutation(meal) {
  const mutation = `mutation {
    mealSave(meal: ${JSON.stringify(meal).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}) { id }
  }`;
  return mutation;
}
